export enum State {
  INIT = 'init',

  RESEARCH_EXPERIMENT_EVALUATION = 'research-experiment-evaluation',
  RESEARCH_EXPERIMENT = 'research-experiment',
  RESEARCH_ACCEPTED = 'research-accepted',

  ABORT_TO_RESET_PROMPT = 'abort-to-reset-prompt',

  DONE = 'done',
  ABORT = 'abort',
}
